import React from 'react';
import { useNavigate } from 'react-router-dom';
import OnBoard from './index';


export function OnBoardNavigate(props) {
    let navigate = useNavigate();
    return <OnBoard navigate={navigate}/>
}